export default __webpack_public_path__ + "static/media/desktop_banner_liability.31188fb8.jpg";